/**
 * Project type enum for discriminating between project types
 */ export var ProjectTypeEnum = /*#__PURE__*/ function(ProjectTypeEnum) {
    ProjectTypeEnum["GENERIC"] = "generic";
    ProjectTypeEnum["CAPTURE"] = "capture";
    ProjectTypeEnum["PROPOSAL"] = "proposal";
    ProjectTypeEnum["DELIVERY"] = "delivery";
    return ProjectTypeEnum;
}({});
/**
 * Contract type classifications used in government contracting
 */ export var ContractType = /*#__PURE__*/ function(ContractType) {
    ContractType["FFP"] = "FFP";
    ContractType["CPFF"] = "CPFF";
    ContractType["CPIF"] = "CPIF";
    ContractType["CPAF"] = "CPAF";
    ContractType["TM"] = "T&M";
    ContractType["LH"] = "LH";
    ContractType["IDIQ"] = "IDIQ";
    ContractType["HYBRID"] = "HYBRID";
    ContractType["OTHER"] = "OTHER";
    return ContractType;
}({});
/**
 * Set-aside types for small business programs
 */ export var SetAsideType = /*#__PURE__*/ function(SetAsideType) {
    SetAsideType["NONE"] = "none";
    SetAsideType["SMALL_BUSINESS"] = "small_business";
    SetAsideType["EIGHT_A"] = "8a";
    SetAsideType["HUB_ZONE"] = "hubzone";
    SetAsideType["SDVOSB"] = "sdvosb";
    SetAsideType["WOSB"] = "wosb";
    SetAsideType["EDWOSB"] = "edwosb";
    return SetAsideType;
}({});
/**
 * Document type classifications for government solicitations
 */ export var DocumentType = /*#__PURE__*/ function(DocumentType) {
    DocumentType["RFP"] = "RFP";
    DocumentType["RFQ"] = "RFQ";
    DocumentType["RFI"] = "RFI";
    DocumentType["SECTION_A"] = "SECTION_A";
    DocumentType["SECTION_B"] = "SECTION_B";
    DocumentType["SECTION_C"] = "SECTION_C";
    DocumentType["SECTION_L"] = "SECTION_L";
    DocumentType["SECTION_M"] = "SECTION_M";
    DocumentType["PWS"] = "PWS";
    DocumentType["SOW"] = "SOW";
    DocumentType["AMENDMENT"] = "AMENDMENT";
    DocumentType["QA"] = "Q&A";
    DocumentType["ATTACHMENT"] = "ATTACHMENT";
    return DocumentType;
}({});
/**
 * Requirement type classifications
 */ export var RequirementType = /*#__PURE__*/ function(RequirementType) {
    RequirementType["FORMAT"] = "format";
    RequirementType["CONTENT"] = "content";
    RequirementType["SUBMISSION"] = "submission";
    RequirementType["PERFORMANCE"] = "performance";
    RequirementType["DELIVERABLE"] = "deliverable";
    RequirementType["EVALUATION"] = "evaluation";
    RequirementType["QUALIFICATION"] = "qualification";
    return RequirementType;
}({});
/**
 * Obligation strength based on modal verbs in requirements
 * Used to determine if a requirement is mandatory or optional
 */ export var ObligationStrength = /*#__PURE__*/ function(ObligationStrength) {
    ObligationStrength["SHALL"] = "SHALL";
    ObligationStrength["SHALL_NOT"] = "SHALL NOT";
    ObligationStrength["MUST"] = "MUST";
    ObligationStrength["MUST_NOT"] = "MUST NOT";
    ObligationStrength["WILL"] = "WILL";
    ObligationStrength["WILL_NOT"] = "WILL NOT";
    ObligationStrength["SHOULD"] = "SHOULD";
    ObligationStrength["SHOULD_NOT"] = "SHOULD NOT";
    ObligationStrength["MAY"] = "MAY";
    ObligationStrength["MAY_NOT"] = "MAY NOT";
    return ObligationStrength;
}({});
/**
 * Requirement category for compliance matrix organization
 */ export var RequirementCategory = /*#__PURE__*/ function(RequirementCategory) {
    RequirementCategory["PROPOSAL_INSTRUCTION"] = "PROPOSAL_INSTRUCTION";
    RequirementCategory["FORMAT_REQUIREMENT"] = "FORMAT_REQUIREMENT";
    RequirementCategory["SUBMISSION_REQUIREMENT"] = "SUBMISSION_REQUIREMENT";
    RequirementCategory["SCOPE_REQUIREMENT"] = "SCOPE_REQUIREMENT";
    RequirementCategory["PERFORMANCE_STANDARD"] = "PERFORMANCE_STANDARD";
    RequirementCategory["DELIVERABLE"] = "DELIVERABLE";
    RequirementCategory["EVALUATION_CRITERION"] = "EVALUATION_CRITERION";
    RequirementCategory["QUALIFICATION"] = "QUALIFICATION";
    RequirementCategory["CLAUSE_FLOWDOWN"] = "CLAUSE_FLOWDOWN";
    RequirementCategory["COMPLIANCE_REQUIREMENT"] = "COMPLIANCE_REQUIREMENT";
    RequirementCategory["REPORTING_REQUIREMENT"] = "REPORTING_REQUIREMENT";
    RequirementCategory["KEY_PERSONNEL"] = "KEY_PERSONNEL";
    RequirementCategory["PERIOD_OF_PERFORMANCE"] = "PERIOD_OF_PERFORMANCE";
    RequirementCategory["PLACE_OF_PERFORMANCE"] = "PLACE_OF_PERFORMANCE";
    RequirementCategory["TASK_REQUIREMENT"] = "TASK_REQUIREMENT";
    RequirementCategory["SECURITY_REQUIREMENT"] = "SECURITY_REQUIREMENT";
    RequirementCategory["CLIN"] = "CLIN";
    RequirementCategory["OTHER"] = "OTHER";
    return RequirementCategory;
}({});
/**
 * Compliance status for tracking requirement completion
 */ export var ComplianceStatus = /*#__PURE__*/ function(ComplianceStatus) {
    ComplianceStatus["NOT_STARTED"] = "NOT_STARTED";
    ComplianceStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ComplianceStatus["ADDRESSED"] = "ADDRESSED";
    ComplianceStatus["PARTIAL"] = "PARTIAL";
    ComplianceStatus["NON_COMPLIANT"] = "NON_COMPLIANT";
    ComplianceStatus["NOT_APPLICABLE"] = "N/A";
    return ComplianceStatus;
}({});
/**
 * Option type for CLINs (base period vs option periods)
 */ export var OptionType = /*#__PURE__*/ function(OptionType) {
    OptionType["BASE"] = "base";
    OptionType["OPTION_PERIOD"] = "option_period";
    OptionType["OPTIONAL_TASK"] = "optional_task";
    return OptionType;
}({});
/**
 * Funding status for contract line items
 */ export var FundingStatus = /*#__PURE__*/ function(FundingStatus) {
    FundingStatus["FUNDED"] = "funded";
    FundingStatus["PARTIALLY_FUNDED"] = "partially_funded";
    FundingStatus["UNFUNDED"] = "unfunded";
    FundingStatus["TRACK_5"] = "track_5";
    return FundingStatus;
}({});
/**
 * @deprecated Use string level field in ILaborCategory instead
 */ export var EducationLevel = /*#__PURE__*/ function(EducationLevel) {
    EducationLevel["HIGH_SCHOOL"] = "high_school";
    EducationLevel["ASSOCIATE"] = "associate";
    EducationLevel["BACHELOR"] = "bachelor";
    EducationLevel["MASTER"] = "master";
    EducationLevel["PHD"] = "phd";
    EducationLevel["NONE_SPECIFIED"] = "none";
    return EducationLevel;
}({});
/**
 * @deprecated Clearance information not currently in LCAT data
 */ export var ClearanceLevel = /*#__PURE__*/ function(ClearanceLevel) {
    ClearanceLevel["NONE"] = "none";
    ClearanceLevel["PUBLIC_TRUST"] = "public_trust";
    ClearanceLevel["SECRET"] = "secret";
    ClearanceLevel["TOP_SECRET"] = "top_secret";
    ClearanceLevel["TS_SCI"] = "ts_sci";
    return ClearanceLevel;
}({});
/**
 * Volume types for proposal organization
 */ export var VolumeType = /*#__PURE__*/ function(VolumeType) {
    VolumeType["TECHNICAL"] = "technical";
    VolumeType["MANAGEMENT"] = "management";
    VolumeType["COST"] = "cost";
    VolumeType["PAST_PERFORMANCE"] = "past_performance";
    VolumeType["ADMINISTRATIVE"] = "administrative";
    VolumeType["OTHER"] = "other";
    return VolumeType;
}({});
/**
 * Volume completion status
 */ export var VolumeStatus = /*#__PURE__*/ function(VolumeStatus) {
    VolumeStatus["NOT_STARTED"] = "not_started";
    VolumeStatus["IN_PROGRESS"] = "in_progress";
    VolumeStatus["DRAFT_COMPLETE"] = "draft_complete";
    VolumeStatus["IN_REVIEW"] = "in_review";
    VolumeStatus["FINAL"] = "final";
    return VolumeStatus;
}({});
